import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function FluorescentDyesUseCase() {
  return (
    <>
    <section
      id="fluorescent-dyes"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">

        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Fluorescent & Laser Dyes
          </h1>
          <p className="text-slate-300 space-y-2">
            Fluorescent dyes are essential materials in imaging, diagnostics, sensing, laser technologies, and optoelectronics. Their ability to absorb light and re-emit it at specific wavelengths underpins applications in bioimaging, flow cytometry, fluorescence microscopy, OLED emitters, and security inks.

            <br /><br />

            The performance of a dye depends on high molar absorption, strong fluorescence quantum yield, minimal aggregation, tunable spectral properties, and resistance to photobleaching. Developers and formulators require precise molecular control over Stokes shift, lifetime, solubility, brightness, and spectral overlap for energy transfer or multiplexing.

            <br /><br />

            But discovering new dye structures with optimal spectral and photophysical profiles is time-consuming. Traditional workflows rely heavily on manual synthesis and trial-and-error screening across solvent environments and matrix formulations.
          </p>
        </div>

        {/* How Apoello Helps */}
<div className="space-y-4">
  <h2 className="text-2xl font-semibold text-orange-300">How DiaDEM™ helps</h2>
  <ul className="list-disc list-inside text-slate-300 space-y-2">
    <li>
      Screen millions of molecules for strong visible-range absorption and efficient emission based on precomputed optical gaps and oscillator strengths.
    </li>
    <li>
      Identify bright candidates with high quantum yield potential using excited-state energy and reorganisation energy estimates.
    </li>
    <li>
      Assess solubility and flag toxic compounds before synthesis.
    </li>
    <li>
      Procure ready-to-order dyes or intermediates.
    </li>
  </ul>
</div>
        {/* Why It Matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why It Matters</h2>
          <p className="text-slate-300 max-w-3xl">
            The fluorescent dye industry is rapidly evolving — with demand for next-generation probes in biotechnology, sensing, displays, and security. DiaDEM™ empowers dye manufacturers, formulators, and researchers to explore a wider chemical space, reduce screening costs, and accelerate time-to-market for novel, high-performance fluorophores.
          </p>
        </div>

        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>

      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
